import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaCurso = (): TabelaColuna => ({
  Chave: 'curso',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 250 }}>Curso</div>
})
